import config from "config/config";
import HandleApiResponse from "utils/handleApiResponse";

const submitResignation = () => {
  const { handleResponse, handleError } = HandleApiResponse();

   async function getExitReasonsAPI() {
        try {
          const obj = {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          };
        //   const query = JSON.stringify(values);
          const res = await fetch(
             `${config.host}/panel/ems/exitReasons`,
            obj
          );
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }

      async function getInvoluntaryExitReasonsAPI() {
        try {
          const obj = {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          };
        //   const query = JSON.stringify(values);
          const res = await fetch(
             `${config.host}/panel/ems/involuntaryExitReasons`,
            obj
          );
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }

        async function getAllActiveEmployees() {
          try {
            const obj = {
              method: "GET",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
              },
            };
            let res = await fetch(
              `${config.host}/panel/ems/allActiveEmployees`,
              obj
            );
            return handleResponse(res);
          } catch (err) {
            handleError(err);
          }
        }

      async function getResignStatusAPI() {
        try {
          const obj = {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          };
        //   const query = JSON.stringify(values);
          const res = await fetch(
             `${config.host}/panel/ems/employeeExitDetails`,
            obj
          );
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }

      async function submitResignationAPI(value) {
          try {
            const obj = {
              method: "Post",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(value),
            };
            let res = await fetch(
               `${config.host}/panel/ems/submitResignation`,
                 obj
                );
            return handleResponse(res);
          } catch (err) {
            handleError(err);
          }
        }

         async function submitInvoluntaryResignationAPI(value) {
          try {
            const obj = {
              method: "Post",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(value),
            };
            let res = await fetch(
               `${config.host}/panel/ems/submitInvoluntaryResignation`,
                 obj
                );
            return handleResponse(res);
          } catch (err) {
            handleError(err);
          }
        }

        async function withdrawResignationAPI(values) {
          try {
            const obj = {
              method: "Post",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
              },
             
            };
            // const query = JSON.stringify(values);
            let res = await fetch(
               `${config.host}/panel/ems/withdrawResignation?exitId=${values}`,
                 obj
                );
            return handleResponse(res);
          } catch (err) {
            handleError(err);
          }
        }
  
         async function getInterviewQuestionAPI() {
        try {
          const obj = {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          };
        //   const query = JSON.stringify(values);
          const res = await fetch(
            `${config.host}/panel/ems/interview/questions`,
            obj
          );
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }

      async function submitInterviewResponseAPI(value) {
          try {
            const obj = {
              method: "Post",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(value),
            };
            let res = await fetch(
              `${config.host}/panel/ems/interview/response`,
                 obj
                );
            return handleResponse(res);
          } catch (err) {
            handleError(err);
          }
        }


  return {
    getExitReasonsAPI,
    getInvoluntaryExitReasonsAPI,
    getAllActiveEmployees,
    getResignStatusAPI,
    submitResignationAPI,
    withdrawResignationAPI,
    getInterviewQuestionAPI,
    submitInterviewResponseAPI,
    submitInvoluntaryResignationAPI
  }

}

export default submitResignation;
